import type { ComponentType, FC } from 'react';
import React, { useCallback, useContext } from 'react';

import {
	IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE,
	TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE,
	ExperienceTrackerContext,
} from '@confluence/experience-tracker';
import { Attribution, TransparentErrorBoundary } from '@confluence/error-boundary';

export function withErrorBoundary<P extends {}>(
	CategorySelectorComponent: ComponentType<P>,
): FC<P> {
	return (props: P) => {
		const experienceTracker = useContext(ExperienceTrackerContext);
		const failCategoriesExperience = useCallback(
			(error: Error) => {
				experienceTracker.fail({
					name: IN_EDITOR_TEMPLATES_LOAD_PANEL_CATEGORIES_EXPERIENCE,
					error,
				});
				experienceTracker.fail({
					name: TEMPLATE_GALLERY_CATEGORIES_EXPERIENCE,
					error,
				});
			},
			[experienceTracker],
		);

		return (
			<TransparentErrorBoundary
				attribution={Attribution.TAILORED_EXPERIENCES}
				onError={failCategoriesExperience}
			>
				<CategorySelectorComponent {...props} />
			</TransparentErrorBoundary>
		);
	};
}
